export default __webpack_public_path__ + "static/media/wep4.03f36eae.jpg";